/**
 * VR Creative Platform - Main Application Entry Point
 * Loads random demo worlds at startup
 */

import { DemoWorlds } from './demo-worlds.js';
import { WorldLoader } from './world-loader.js';

console.log('🚀 VR Creative Platform loading...');

let worldLoader = null;
let currentWorld = null;

document.addEventListener('DOMContentLoaded', () => {
    const scene = document.querySelector('a-scene');
    
    if (scene) {
        scene.addEventListener('loaded', () => {
            console.log('✅ VR Scene loaded successfully');
            
            // Initialize world loader
            worldLoader = new WorldLoader(scene);
            worldLoader.init();
            
            // Load random demo world
            currentWorld = worldLoader.loadRandomWorld();
            
            // Hide loading screen
            hideLoadingScreen();
            
            // Show world selector UI
            showWorldSelector();
            
            // Set up world controls
            setupWorldControls();
            
            console.log(`🌍 Welcome to: ${currentWorld.name}!`);
        });
    }
});

function hideLoadingScreen() {
    const loadingScreen = document.getElementById('loading-screen');
    if (loadingScreen) {
        loadingScreen.style.opacity = '0';
        setTimeout(() => {
            loadingScreen.style.display = 'none';
        }, 500);
    }
}

function showWorldSelector() {
    if (!document.getElementById('world-info')) {
        const worldInfo = document.createElement('div');
        worldInfo.id = 'world-info';
        worldInfo.className = 'world-info';
        worldInfo.style.cssText = 'position:fixed;top:80px;left:50%;transform:translateX(-50%);background:rgba(26,26,46,0.95);padding:20px 30px;border-radius:15px;border:2px solid #4CC3D9;text-align:center;z-index:1000;max-width:400px;box-shadow:0 8px 32px rgba(0,0,0,0.5);color:white';
        document.body.appendChild(worldInfo);
    }
}

function setupWorldControls() {
    console.log('✅ Controls ready - Press R for random world');
}

window.vrApp = { worldLoader, currentWorld, DemoWorlds };
console.log('✅ Application initialized');
